import React from 'react';
import TeaserStory from '../Page/TeaserStory';
import TeaserCaseStudy from '../Page/TeaserCaseStudy';
import { TeaserArticle } from '../Page/TeaserArticle';
import TeaserVideo from '../Page/TeaserVideo';

import { useVideoModal } from '../../hooks/useVideoModal';

const PrismicSliceContentTeaser = ({ slice }) => {
  const { openVideoModal } = useVideoModal();

  switch (slice.primary.content.document?.type) {
    case 'video':
      return (
        <TeaserVideo
          video={slice.primary.content.document}
          watchVideoSetState={openVideoModal}
        />
      );
    case 'story':
      return (
        <TeaserStory
          node={slice.primary.content.document}
          className=""
        />
      );
    case 'article':
      return (
        <TeaserArticle
          node={slice.primary.content.document}
          className=""
        />
      );
    case 'case_study':
      return (
        <TeaserCaseStudy
          node={slice.primary.content.document}
          className=""
        />
      );
    default:
      return null;
  }
};

export default PrismicSliceContentTeaser;
